<div class="splide" #carousel_ref [id]="uuid" [ngClass]="from_courts ? 'splide__courts' : ''">
    <div class="splide__track" [ngClass]="isTwitter ? 'splide__twitter' : ''">
        <ul class="splide__list">
            <ng-content></ng-content>
        </ul>
    </div>
</div>
